import { render } from "./NewImages.vue?vue&type=template&id=65170426&scoped=true"
import script from "./NewImages.vue?vue&type=script&lang=js"
export * from "./NewImages.vue?vue&type=script&lang=js"

import "./NewImages.vue?vue&type=style&index=0&id=65170426&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65170426"]])

export default __exports__